/* .card-template {
  width: 400px;
  border-radius: 20px;
  background-color: #f0f0f0;
}
.card-header {
  display: flex;
  align-items: center;
  gap: 1rem;
}
.card-body {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  color: black;
}
.card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
} */